import { useEffect, useCallback, useState } from '@wordpress/element';
import moment from 'moment';
import { getCurrentPostAcfFields } from '../utils/methods';
import $ from 'jquery';

const { useSelect } = wp.data;
const { registerBlockType } = wp.blocks;
const { RichText } = wp.blockEditor;
const { Fragment } = wp.element;
const { __ } = wp.i18n;
const { Button, Icon, TextControl, PanelBody, SelectControl } = wp.components;

registerBlockType('pg/event-inner-details', {
  title: 'PG Event Inner About Block',
  icon: 'calendar-alt',
  category: 'layout',
  parent: ['pg/event-content'],
  attributes: {
    title: { type: 'string', default: 'About the event' },
    content: { type: 'string', default: '' },
    dateLabel: { type: 'string', default: 'Date' },
    addressLabel: { type: 'string', default: 'Address' },
    transportationLabel: { type: 'string', default: 'Transportation' },
    eventDate: { type: 'string', default: '' },
    eventAddress: { type: 'string', default: '' },
    eventTransporation: { type: 'string', default: '' },
    additionalDetails: {
      type: 'array',
      default: [],
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const {
      title,
      content,
      dateLabel,
      addressLabel,
      transportationLabel,
      eventDate,
      eventAddress,
      eventTransporation,
      additionalDetails,
    } = attributes;

    const addDetail = () => {
      const newDetails = [
        ...additionalDetails,
        { label: 'New Detail', description: '' },
      ];
      setAttributes({ additionalDetails: newDetails });
    };

    const removeDetail = (index) => {
      const newDetails = additionalDetails.filter((_, i) => i !== index);
      setAttributes({ additionalDetails: newDetails });
    };

    const updateDetail = (index, key, value) => {
      const newDetails = additionalDetails.map((detail, i) =>
        i === index ? { ...detail, [key]: value } : detail
      );
      setAttributes({ additionalDetails: newDetails });
    };

    return (
      <Fragment>
        <div className="block-wrapper">
          <div className="text-block">
            <RichText
              tagName="h3"
              value={title}
              className="event-title"
              placeholder={__('Enter title...')}
              onChange={(value) => setAttributes({ title: value })}
            />
            <RichText
              tagName="div"
              value={content}
              className="event-content"
              placeholder={__('Enter content...')}
              onChange={(value) => setAttributes({ content: value })}
            />
          </div>

          <div className="details-block">
            <div>
              <RichText
                tagName="h5"
                value={dateLabel}
                className="date-label"
                placeholder={__('Date')}
                onChange={(value) => setAttributes({ dateLabel: value })}
              />
              <div className="description">{eventDate}</div>
            </div>

            <div>
              <RichText
                tagName="h5"
                value={addressLabel}
                className="address-label"
                placeholder={__('Address')}
                onChange={(value) => setAttributes({ addressLabel: value })}
              />
              <div className="description">{eventAddress}</div>
            </div>

            <div>
              <RichText
                tagName="h5"
                value={transportationLabel}
                className="transportation-label"
                placeholder={__('Transportation')}
                onChange={(value) =>
                  setAttributes({ transportationLabel: value })
                }
              />
              <div className="description">{eventTransporation}</div>
            </div>

            {additionalDetails.map((detail, index) => (
              <div key={index}>
                <RichText
                  tagName="h5"
                  value={detail.label}
                  className="detail-label"
                  placeholder={__('Enter label...')}
                  onChange={(value) => updateDetail(index, 'label', value)}
                />
                <RichText
                  tagName="div"
                  value={detail.description}
                  className="description"
                  placeholder={__('Enter description...')}
                  onChange={(value) =>
                    updateDetail(index, 'description', value)
                  }
                />
                <Button
                  isSmall
                  isPrimary
                  className="removeStaticButton"
                  onClick={() => removeDetail(index)}
                >
                  <Icon icon="trash" /> {__('Remove Detail')}
                </Button>
              </div>
            ))}
            <button
              isSmall
              isSecondary
              className="addButton"
              onClick={addDetail}
            >
              Add Detail
            </button>
          </div>
        </div>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const {
      title,
      content,
      dateLabel,
      addressLabel,
      transportationLabel,
      eventDate,
      eventAddress,
      eventTransporation,
      additionalDetails,
    } = attributes;

    return (
      <div className="block-wrapper">
        <div className="text-block">
          <h3 className="event-title">{title}</h3>
          <div
            className="event-content"
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </div>

        <div className="details-block">
          <div>
            <h5 className="date-label">{dateLabel}</h5>
            <div className="description">{eventDate}</div>
          </div>

          <div>
            <h5 className="address-label">{addressLabel}</h5>
            <div className="description">{eventAddress}</div>
          </div>

          <div>
            <h5 className="transportation-label">{transportationLabel}</h5>
            <div className="description">{eventTransporation}</div>
          </div>

          {additionalDetails.map((detail, index) => (
            <div key={index}>
              <h5 className="detail-label">{detail.label}</h5>
              <div className="description">{detail.description}</div>
            </div>
          ))}
        </div>
      </div>
    );
  },
});
